export interface User {
  name: string;
  email?: string;
  groups?: string[];
  preferred_username?: string;
}

export interface AuthState {
  user: User | null;
  accessToken: string | null;
  isAuthenticated: boolean;
  isLoading: boolean;
}

type Listener = (state: AuthState) => void;

export class AuthStore {
  private state: AuthState = {
    user: null,
    accessToken: null,
    isAuthenticated: false,
    isLoading: false,
  };

  private listeners: Set<Listener> = new Set();

  getState(): AuthState {
    return { ...this.state };
  }

  subscribe(listener: Listener): () => void {
    this.listeners.add(listener);
    return () => this.listeners.delete(listener);
  }

  private notify() {
    this.listeners.forEach((listener) => listener(this.state));
  }

  setUser(user: User, token: string) {
    this.state = {
      user,
      accessToken: token,
      isAuthenticated: true,
      isLoading: false,
    };
    this.notify();
  }

  clearUser() {
    this.state = {
      user: null,
      accessToken: null,
      isAuthenticated: false,
      isLoading: false,
    };
    this.notify();
  }

  setLoading(isLoading: boolean) {
    this.state = { ...this.state, isLoading };
    this.notify();
  }
}

export const authStore = new AuthStore();
